export default __webpack_public_path__ + "static/media/Group14351.b28a79c6.svg";